<template>
  <div class="component__collapsible">
    <h3
      @click="toggle"
      @keydown.enter="toggle"
      @keydown.space.prevent="toggle"
      class="mb-0"
      role="button"
      :class="{
        'd-flex align-item-center justify-content-between': !isDisabled,
        active: isActive,
        'toggle--disabled': isDisabled,
      }"
      :aria-expanded="isActive ? 'true' : 'false'"
      :aria-controls="'collapsible-content-' + _uid"
    >
      <template v-if="img">
        <img :src="img" alt="">
      </template>
      <div><strong><slot name="title"></slot></strong></div>
      <div class="toggle text-lowercase" v-if="!isDisabled">
        <span class="toggle_text" v-if="showToggleDescription">
          {{ isActive ? "Hide" : "Show" }}
        </span>
        <span class="toggle__icon"></span>
      </div>
    </h3>
    <collapse-transition>
      <div
        v-show="isActive || isDisabled"
        :id="'collapsible-content-' + _uid"
        class="accordion__description"
      >
        <slot></slot>
      </div>
    </collapse-transition>
  </div>
</template>

<script>
/*
* Collapsible Vue component
* ---
* Example usage:
*
* <collapsible>
*   <template v-slot:title>Accordion Title</template>
*   <template>Lorem ipsum dolor sit amet, consectetur adipiscing elit.</template>
* </collapsible>
* 
* <collapsible show-toggle-description="true"> will show Show/Hide text
* <collapsible :is-disabled="$mq > 2">  will disable (automatically show the contents) above VueMq breakpoint 2
*/

import {CollapseTransition} from 'vue2-transitions';

export default {
    components: {
        CollapseTransition
    },

    props: ["showToggleDescription", "isDisabled", "img", 'active'],

    data: function () {
        return {
            isActive: this.active
        }
    },        

    methods: {
        toggle: function () {
            if (this.isDisabled) return;
            this.isActive = !this.isActive;
        },

        close: function () {
            if (this.isDisabled) return;
            this.isActive = false;
        },
        
        open: function () {
            if (this.isDisabled) return;
            this.isActive = true;
        }
    },

    created() {
        if (this.isDisabled) {
            this.isActive = true;
        }
    }
}
</script>

<style lang="scss" scoped>
h3 {
    cursor: pointer;
    font-size: 11px;
    border-bottom: 1px solid #7c7c7c;
    padding: 15px 0;

    &.toggle--disabled {
        border-bottom: 0;
        pointer-events: none;
    }
}

.toggle {
    position: relative;
    padding-right: 20px;
    color: #7c7c7c;

    &__icon {
        transition: all 0.3s ease-in-out;
        transform: rotate(180deg);
        height: 10px;
        width: 13px;
        display: block;
        position: absolute;
        right: 0;
        top: 2px;
        background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='13' height='10' viewBox='0 0 13 10'%3E%3Cpath fill='%23000' fill-rule='nonzero' d='M10.631 8.5L6.5 2.303 2.368 8.5h8.263zm1.869 1H.5l6-9 6 9z'/%3E%3C/svg%3E");
        background-repeat: none;
        background-size: 13px 10px;
    }
    
    .active & {
        .toggle__icon {
            transform: rotate(0deg);
        }
    }

    .accordion__description {
        border-bottom: 1px solid #7c7c7c;
    }
}
</style>
